const LandingPage = () =>
  import(
    /* webpackChunkName: "mweb-government-revenue-landing-page" */ '../components/pages/Landing'
  )
const InquiryResultPage = () =>
  import(
    /* webpackChunkName: "mweb-government-revenue-inquiry-result-page" */ '../components/pages/InquiryResult'
  )
const ReceiptPage = () =>
  import(
    /* webpackChunkName: "mweb-government-revenue-receipt-page" */ '../components/pages/Receipt'
  )
const SelectPaymentPage = () =>
  import(
    /* webpackChunkName: "mweb-government-revenue-select-payment-page" */ '../components/pages/SelectPayment'
  );

export default [
  { path: '/inquiry', component: InquiryResultPage, name: 'inquiry_result_page' },
  { path: '/adjust_payment', component: SelectPaymentPage, name: 'select_payment_page' },
  { path: '/receipt', component: ReceiptPage, name: 'receipt' },
  { path: '/receipt/:id', component: ReceiptPage, name: 'receipt-with-id' },
  { path: '/:category/:subcategory', component: LandingPage, name: 'landing_with_slug_page' },
  { path: '/:category', component: LandingPage, name: 'landing_with_slug_page' },
  { path: '/', component: LandingPage, name: 'landing_page' },
  { path: '*', redirect: { name: 'landing_page' } },
];
